import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import IndustrialMarquee from "@/components/site/IndustrialMarquee";
import About from "@/components/site/About";
import Products from "@/components/site/Products";
import References from "@/components/site/References";
import Team from "@/components/site/Team";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import WhatsAppFloat from "@/components/site/WhatsAppFloat";

export default function Home() {
  return (
    <div data-testid="home-page" className="min-h-screen bg-[#fafafa] text-gray-900">
      <Navbar />
      <main>
        <Hero />
        <IndustrialMarquee />
        <About />
        <Products />
        <References />
        <Team />
        <Contact />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
